// extracted by mini-css-extract-plugin
export default {"h1":"Htag_h1__pbXd0","h2":"Htag_h2__2OPlZ","h3":"Htag_h3__UYSU2"};